import React from "react";
import { TableCell, TableCellProps } from "@mui/material";

import "./collapsibleTableCell.sass";

interface ICollapsibleTableCellProps {
    expanded: boolean;
    tableCellClassName?: string;
    tableCellProps?: TableCellProps;
}

const CollapsibleTableCell: React.FC<ICollapsibleTableCellProps> = ({
    expanded,
    tableCellClassName,
    tableCellProps,
    children
}) => {
    return <TableCell className={tableCellClassName} {...tableCellProps}>
        <div className={`collapsible-table-cell-div ${expanded ? "expanded" : ""}`}>
            {children}
        </div>
    </TableCell>;
};

export default CollapsibleTableCell;
